import { render, staticRenderFns } from "./short.vue?vue&type=template&id=042e1a67&"
import script from "./short.vue?vue&type=script&lang=js&"
export * from "./short.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports